module.exports = __webpack_public_path__ + "static/media/screen.3338ea37.svg";